<template xmlns:v-b-popover="http://www.w3.org/1999/xhtml">
  <div>
    <h4 class="text-center">Telegram</h4>
    <div class="mt-5">
      <form @submit.prevent="promiseConnectAccessToken = connectTelegram()">

        <div class="form-group row mt-3">
          <label class="col-4 text-muted col-form-label">
            Token:
            <span id="token_info" v-b-popover:token_info.html.hover.right="popoverText">
              <icon name="info-circle"></icon>
            </span>
          </label>
          <div class="col-8">
            <input class="form-control"
                   :class="{'is-invalid': isAccessTokenInvalid || serverErrorMessage}"
                   v-model="accessToken"/>
            <div v-show="isAccessTokenInvalid" class="invalid-feedback">
              Please provide Telegram Token.
            </div>
            <div v-show="serverErrorMessage" class="invalid-feedback">
              {{ serverErrorMessage }}
            </div>
          </div>
        </div>

        <div class="row mt-5">
          <div class="col-12 d-flex justify-content-center">
            <button class="btn btn-primary px-5"
                    v-busy-button="promiseConnectAccessToken">
              Connect
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import channelService from '@/services/amio-api/channel.service'
  import 'vue-awesome/icons/info-circle'
  import CopyButton from '@/components/common/CopyButton'

  const popoverText = '<b>Token</b> is a unique authentication key that was assigned to your bot upon creation. ' +
    'It looks something like <code>110201543:AAHdqTcvCH1vGWJxfSeofSAsTcvCH1vGW</code>.<br /><br />' +
    'If you need to regenerate the token follow <a href="https://core.telegram.org/bots#generating-an-authorization-token" target="_blank">Telegram tutorial</a>.'

  export default {
    components: {
      CopyButton
    },
    data() {
      return {
        promiseConnectAccessToken: null,
        popoverText,
        isAccessTokenInvalid: false,
        accessToken: '',
        serverErrorMessage: ''
      }
    },

    methods: {
      connectTelegram() {
        this.clearError()
        if (!this.accessToken) {
          this.isAccessTokenInvalid = true
          return
        }

        this.isAccessTokenInvalid = false
        const data = {
          type: 'telegram',
          telegram: {
            access_token: this.accessToken
          }
        }
        return channelService.create(data, [422])
          .then(channel => {
            this.channel = channel
            this.$router.push({name: 'administration.channel-detail.info', params: {id: channel.id}})
          })
          .catch((err) => {
            if (err.response.status !== 422) return

            const error = err.response.data.errors ? err.response.data.errors[0] : {}
            return this.handleError(error)
          })
          .then(() => {
            this.promiseConnectAccessToken = null
          })
      },

      clearError() {
        this.serverErrorMessage = ''
      },

      handleError(error) {
        this.serverErrorMessage = error.message
      }
    }
  }
</script>
